import { useState } from "react";
import { Loader2, MessageCircle } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import { LOGO_URL } from "@/lib/quoteContent";

export function DeclinedScreen({ slug }) {
  const [requested, setRequested] = useState(false);
  const [loading, setLoading] = useState(false);

  async function requestReactivation() {
    setLoading(true);
    try {
      await axios.post(`${API}/public/quotes/${slug}/request-reactivation`);
    } catch (e) {
      console.warn("Reactivation request failed; confirmation still shown", e);
    } finally {
      setRequested(true);
      setLoading(false);
    }
  }

  return (
    <div
      data-testid="quote-declined-screen"
      className="min-h-screen bg-[#21201F] text-white flex flex-col items-center justify-center px-6 text-center"
    >
      <img
        src={LOGO_URL}
        alt="Wedding Video Essex"
        className="h-24 md:h-28 w-auto object-contain brightness-0 invert opacity-95 mb-10"
      />
      <div className="text-xs tracking-overline uppercase text-[#A9927D] mb-4 font-medium">
        With Our Very Best Wishes
      </div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tight leading-tight mb-6 max-w-3xl">
        Thank you for considering us.
      </h1>
      <p className="text-white/70 max-w-lg mb-6 leading-relaxed">
        This quote is no longer active, but we genuinely mean it when we say
        thank you for thinking of us for your wedding day. It means a lot.
      </p>
      <p className="text-white/70 max-w-lg mb-10 leading-relaxed">
        Whoever captures it for you, we hope your day is everything you've
        dreamed of and more. Wishing you both a lifetime of happiness together.
      </p>
      <p className="text-white/50 text-sm max-w-md mb-8 leading-relaxed">
        And if your plans ever change, our door is always open.
      </p>
      {requested ? (
        <div
          data-testid="declined-reactivation-confirmed"
          className="bg-white/10 border border-white/20 px-8 py-5 max-w-md text-white/90"
        >
          Thanks! Alex has been notified and will personally refresh your
          quote shortly. Keep an eye on your inbox!
        </div>
      ) : (
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <button
            onClick={requestReactivation}
            disabled={loading}
            data-testid="declined-reactivate-btn"
            className="inline-flex items-center gap-3 bg-[#CCBA56] hover:bg-[#B5A244] text-[#1F1E1D] px-10 py-4 text-xs tracking-overline uppercase font-medium transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />}
            Reactivate Quote
          </button>
          <a
            href="https://wa.link/aorw15"
            target="_blank"
            rel="noreferrer"
            data-testid="declined-whatsapp-btn"
            className="inline-flex items-center gap-3 border border-white/40 hover:border-white text-white px-10 py-4 text-xs tracking-overline uppercase font-medium transition-colors"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
            WhatsApp Us
          </a>
        </div>
      )}
    </div>
  );
}
